"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79624],{

/***/ 56371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ trackOrderDetailShareSelected; },
/* harmony export */   "J4": function() { return /* binding */ trackShareSelected; },
/* harmony export */   "M1": function() { return /* binding */ trackOrderShareSelected; },
/* harmony export */   "cP": function() { return /* binding */ trackTradeSharedViewed; },
/* harmony export */   "g3": function() { return /* binding */ trackOrderViewed; },
/* harmony export */   "tE": function() { return /* binding */ trackDoneSelected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56644);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2078);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);




var _obj;
var orderActionValue = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .iX.Buy, "Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .iX.Sell, "Sell"), _obj);
var _obj1;
var symbolTypeValue = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Right */ .Z.Right, "Right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Waran */ .Z.Waran, "Warrant"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Saham */ .Z.Saham, "Normal"), _obj1);
var _obj2;
var expiryValue = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good for day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good till canceled"), _obj2);
var _obj3;
var statusValue = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Open */ .iF.Open, "Open"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Partial */ .iF.Partial, "Partial"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Match */ .iF.Match, "Match"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Withdrawn */ .iF.Withdrawn, "Withdrawn"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Amended */ .iF.Amended, "Amended"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Rejected */ .iF.Rejected, "Rejected"), _obj3);
// Views
var trackOrderViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Order Viewed");
};
var trackTradeSharedViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Trade Shared Viewed");
};
var trackOrderShareSelected = function(type, symbol) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Share Selected"), {
        Action: "".concat(action, " Order Share Selected"),
        Symbol: symbol
    });
};
// Actions
var trackOrderDetailShareSelected = function(type, orderId, symbol, symbolType, expiry, rejectReason, status) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Detail Share Selected"), {
        Action: "".concat(action, " Order Detail Share Selected"),
        "Order ID": orderId,
        Symbol: symbol,
        "Symbol Type": symbolTypeValue[symbolType] || "Normal",
        Expiry: expiryValue[expiry],
        "Reject Reason": rejectReason,
        Status: statusValue[status]
    });
};
var trackShareSelected = function(symbol, isAddAutoShare) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Share Selected",
        Symbol: symbol,
        "Add Auto Share": isAddAutoShare
    });
};
var trackDoneSelected = function(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Done Selected",
        Symbol: symbol
    });
};


/***/ }),

/***/ 77064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    isVisible: false,
    selectedUsers: {},
    sharedUsers: {},
    orderType: undefined,
    expiry: undefined,
    isDayTrade: false
};
var useShareTradeModal = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setIsVisible: function(isVisible) {
            set({
                isVisible: isVisible
            });
        },
        setSelectedUsers: function(selectedUsers) {
            set({
                selectedUsers: selectedUsers
            });
        },
        setSharedUsers: function(sharedUsers) {
            set({
                sharedUsers: sharedUsers
            });
        },
        setOrderType: function(orderType) {
            set({
                orderType: orderType
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setIsDayTrade: function(isDayTrade) {
            set({
                isDayTrade: isDayTrade
            });
        },
        resetShareTradeModal: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeModal);


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 86408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ getFormula; },
  "u": function() { return /* binding */ postCancel; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/config.ts
var configEndpoint = {
    formula: "/virtualtrading/config/formula",
    cancel: "/virtualtrading/cancel"
};
/* harmony default export */ var config = (configEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/config.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getFormula = function() {
    return defaultInstance.get(config.formula);
};
var postCancel = function(requestBody) {
    return defaultInstance.post(config.cancel, requestBody);
};


/***/ }),

/***/ 47002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36902);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);




var useGetPortfolioData = function(symbol) {
    var refetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, fromAll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, dayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading;
    var ref1 = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), _portfolio = ref1.portfolio, _data = _portfolio.data, realList = _data.result, _portfolioDetail = ref1.portfolioDetail, detail = _portfolioDetail.data, _portfolioDetailDayTrade = ref1.portfolioDetailDayTrade, detailDayTrade = _portfolioDetailDayTrade.data, getPortfolio = ref1.getPortfolio, getPortfolioDetail = ref1.getPortfolioDetail;
    var data = null;
    if (symbol) {
        if (isRealTrading && symbol) {
            if (fromAll) {
                data = realList.find(function(l) {
                    return l.symbol === symbol;
                });
            } else {
                data = dayTrade ? detailDayTrade : detail;
            }
        } else if (isVirtualTrading) {
            data = realList.find(function(l) {
                return l.symbol === symbol;
            });
        }
    } else {
        data = realList;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (refetch) {
            if (isRealTrading && !symbol) {
                getPortfolio(true, !router.asPath.includes("portfolio") && !router.asPath.includes("chartbit"));
            } else if (isRealTrading && symbol) {
                getPortfolioDetail(symbol);
            }
            if (isVirtualTrading) getPortfolio(false);
        }
    }, [
        symbol,
        refetch
    ]);
    return data || {};
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetPortfolioData);


/***/ }),

/***/ 66959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ trackAutoBuyOrderReceivedView; },
/* harmony export */   "FY": function() { return /* binding */ trackAutoBuyOrderConfirmed; },
/* harmony export */   "Fs": function() { return /* binding */ trackAutoBuyDetailView; },
/* harmony export */   "GK": function() { return /* binding */ trackAutoSellAlterOrderView; },
/* harmony export */   "HJ": function() { return /* binding */ trackAutoSellAlterOrderSelected; },
/* harmony export */   "Jl": function() { return /* binding */ trackAutoSellOrderTypeSelected; },
/* harmony export */   "K": function() { return /* binding */ trackAutoSellOrderCanceled; },
/* harmony export */   "PH": function() { return /* binding */ trackAutoBuyOrderView; },
/* harmony export */   "Pz": function() { return /* binding */ trackAutoSellOrderDeleted; },
/* harmony export */   "RI": function() { return /* binding */ trackAutoSellOrderConfirmed; },
/* harmony export */   "Rj": function() { return /* binding */ trackAutoBuyOrderDone; },
/* harmony export */   "V0": function() { return /* binding */ trackAutoSellInfoSelected; },
/* harmony export */   "Vf": function() { return /* binding */ trackAutoSellDeleteCanceled; },
/* harmony export */   "ZY": function() { return /* binding */ trackAutoBuyTriggerConditionSelected; },
/* harmony export */   "_3": function() { return /* binding */ trackAutoBuyConfirmOrderCanceled; },
/* harmony export */   "_E": function() { return /* binding */ trackAutoBuyOrderTypeInfoSelected; },
/* harmony export */   "bG": function() { return /* binding */ trackAutoSellOrderQuantityAdjusted; },
/* harmony export */   "bm": function() { return /* binding */ trackAutoSellOrderSelected; },
/* harmony export */   "dM": function() { return /* binding */ trackAutoBuyOrderTypeSelected; },
/* harmony export */   "fY": function() { return /* binding */ trackAutoBuyOrderCanceled; },
/* harmony export */   "fh": function() { return /* binding */ trackAutoSellOrderInfoClosed; },
/* harmony export */   "gT": function() { return /* binding */ trackAutoBuyTriggerPriceInfoSelected; },
/* harmony export */   "i7": function() { return /* binding */ trackAutoSellFormView; },
/* harmony export */   "iY": function() { return /* binding */ trackAutoOrderCanceled; },
/* harmony export */   "jU": function() { return /* binding */ trackAutoBuyPreviewOrderView; },
/* harmony export */   "pR": function() { return /* binding */ trackAutoBuyOrderPlaced; },
/* harmony export */   "ur": function() { return /* binding */ trackAutoSellAutoOrderView; },
/* harmony export */   "vD": function() { return /* binding */ trackAutoSellInfoView; }
/* harmony export */ });
/* unused harmony exports trackAutoBuyAction, trackAutoBuyTncSelected, trackAutoBuyCancelOrderSelected, trackAutoBuyAmendSelected, trackAutoSellDetailOrderView, trackAutoSellOrderDetailClosed, trackAutoSellOrderTncSelected */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var trackAutoBuyOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Viewed");
};
var trackAutoBuyPreviewOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Previewed");
};
var trackAutoBuyOrderReceivedView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Received Viewed");
};
var trackAutoBuyDetailView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Order Detail Viewed");
};
var trackAutoBuyAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Action", eventObject);
};
var trackAutoBuyOrderTypeSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Set Order Type Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTriggerPriceInfoSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Price Info Selected"
    });
};
/**
 *
 * @param {('≥' | '≤')} condition
 * @returns
 */ var trackAutoBuyTriggerConditionSelected = function(condition) {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Condition Selected",
        Condition: condition
    });
};
var trackAutoBuyOrderTypeInfoSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Order Type Info Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTncSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Smart Order Terms & Conditions Selected"
    });
};
var trackAutoBuyOrderCanceled = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Order Buy Canceled"
    });
};
var trackAutoBuyOrderPlaced = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Placed"
    });
};
var trackAutoBuyConfirmOrderCanceled = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Canceled",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderConfirmed = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Confirmed",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderDone = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Done"
    });
};
var trackAutoBuyCancelOrderSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Cancel Order Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyAmendSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Amend Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
// #endregion Auto Buy
// #region Auto Sell
var trackAutoSellAutoOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Auto Order Viewed");
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellFormView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Viewed"));
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellInfoView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Information Viewed"));
};
var trackAutoSellDetailOrderView = function() {
    clevertapEvent("Auto Sell Detail Auto Order Viewed");
};
/**
 *
 * @param {("Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Auto Order Viewed"));
};
var trackAutoSellAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Action", eventObject);
};
/**
 *
 * @param {string} stock
 */ var trackAutoSellOrderSelected = function(stock) {
    trackAutoSellAction({
        Action: "Auto Sell Set Auto Order Selected",
        Stock: stock
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 */ var trackAutoSellOrderTypeSelected = function(type, stock) {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Type Selected",
        "Auto Sell Type": type,
        Stock: stock
    });
};
var trackAutoOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Canceled"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 */ var trackAutoSellInfoSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Information Selected")
    });
};
var trackAutoSellOrderQuantityAdjusted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Quantity Adjusted"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 * @param {number} lot
 * @param {number} price
 * @param {string} tpPercentage
 * @param {string} slPercentage
 */ var trackAutoSellOrderConfirmed = function(type, stock, lot, price, gainPercentage) {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Confirmed",
        "Auto Sell Type": type,
        Stock: stock,
        Lot: lot,
        Price: price,
        "Take Profit Percentage": type === "Take Profit" ? gainPercentage : 0,
        "Stop Loss Percentage": type === "Stop Loss" ? gainPercentage : 0
    });
};
var trackAutoSellOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Canceled"
    });
};
var trackAutoSellOrderInfoClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Information Closed"
    });
};
var trackAutoSellOrderDetailClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Detail Closed"
    });
};
/**
 *
 * @param {("Add"|"Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Auto Order Selected")
    });
};
var trackAutoSellDeleteCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Delete Canceled"
    });
};
var trackAutoSellOrderDeleted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Deleted"
    });
};
var trackAutoSellOrderTncSelected = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Terms & Conditions Selected"
    });
}; // #endregion Auto Sell


/***/ }),

/***/ 91154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ clevertapDayTradeSortSelected; },
/* harmony export */   "$f": function() { return /* binding */ clevertapExerciseClicked; },
/* harmony export */   "$v": function() { return /* binding */ clevertapDayTradeOrderTypeSelected; },
/* harmony export */   "A2": function() { return /* binding */ clevertapBuyOrderViewed; },
/* harmony export */   "Am": function() { return /* binding */ clevertapDayTradeLeverageSelected; },
/* harmony export */   "As": function() { return /* binding */ clevertapOrderPlaced; },
/* harmony export */   "B0": function() { return /* binding */ clevertapSellOrderViewed; },
/* harmony export */   "C4": function() { return /* binding */ clevertapSetPriceAlertSelected; },
/* harmony export */   "C5": function() { return /* binding */ clevertapDayTradeTNCViewed; },
/* harmony export */   "CH": function() { return /* binding */ clevertapOrderQuantityAdjusted; },
/* harmony export */   "EQ": function() { return /* binding */ clevertapChangeStock; },
/* harmony export */   "F9": function() { return /* binding */ clevertapDayTradeSplitOrderSelected; },
/* harmony export */   "FH": function() { return /* binding */ clevertapSecuritiesTradingPinSubmitted; },
/* harmony export */   "HR": function() { return /* binding */ clevertapDayTradeActivationDismissed; },
/* harmony export */   "J2": function() { return /* binding */ clevertapOrderPreviewed; },
/* harmony export */   "L": function() { return /* binding */ clevertapDayTradeDebtRatioViewed; },
/* harmony export */   "LA": function() { return /* binding */ clevertapViewChartSelected; },
/* harmony export */   "LF": function() { return /* binding */ clevertapExerciseViewed; },
/* harmony export */   "Lx": function() { return /* binding */ clevertapPortfolioDetailExercise; },
/* harmony export */   "Nf": function() { return /* binding */ clevertapDayTradeLeverageOptionViewed; },
/* harmony export */   "Rs": function() { return /* binding */ clevertapOrderTabSelected; },
/* harmony export */   "SW": function() { return /* binding */ clevertapDayTradeDebtRatioSubmitted; },
/* harmony export */   "Sv": function() { return /* binding */ clevertapExchangeFee; },
/* harmony export */   "TD": function() { return /* binding */ clevertapDayTradeDebtRatioChipSelected; },
/* harmony export */   "Uj": function() { return /* binding */ clevertapExerciseSelected; },
/* harmony export */   "V8": function() { return /* binding */ clevertapDayTradeActivationViewed; },
/* harmony export */   "_3": function() { return /* binding */ clevertapOrderDetailAmendViewed; },
/* harmony export */   "_O": function() { return /* binding */ clevertapPortfolioCompanySell; },
/* harmony export */   "_h": function() { return /* binding */ clevertapDayTradeOrderDetailSelected; },
/* harmony export */   "bQ": function() { return /* binding */ clevertapOrderCanceled; },
/* harmony export */   "dQ": function() { return /* binding */ clevertapOrderReceived; },
/* harmony export */   "f0": function() { return /* binding */ clevertapPortfolioBuyMore; },
/* harmony export */   "fn": function() { return /* binding */ clevertapSecuritiesTradingPinViewed; },
/* harmony export */   "hA": function() { return /* binding */ clevertapOrderDetailCancelConfirmed; },
/* harmony export */   "in": function() { return /* binding */ clevertapOrderViewed; },
/* harmony export */   "jS": function() { return /* binding */ clevertapDayTradeAfterMarketViewed; },
/* harmony export */   "kt": function() { return /* binding */ clevertapOrderDetailViewed; },
/* harmony export */   "lH": function() { return /* binding */ clevertapDayTradeActivationSelected; },
/* harmony export */   "mD": function() { return /* binding */ clevertapPortfolioSell; },
/* harmony export */   "mf": function() { return /* binding */ clevertapOrderDetailCancel; },
/* harmony export */   "ng": function() { return /* binding */ clevertapSetVisibleBalance; },
/* harmony export */   "oZ": function() { return /* binding */ clevertapDayTradeLeverageActivationSelected; },
/* harmony export */   "p": function() { return /* binding */ clevertapDayTradeActivationSuccessSelected; },
/* harmony export */   "pl": function() { return /* binding */ clevertapDayTradeActivationSubmitted; },
/* harmony export */   "qj": function() { return /* binding */ clevertapPortfolioDetailViewed; },
/* harmony export */   "r8": function() { return /* binding */ clevertapAutoOrderOptionsViewed; },
/* harmony export */   "rP": function() { return /* binding */ clevertapDayTradeStockListViewed; },
/* harmony export */   "sW": function() { return /* binding */ clevertapExerciseError; },
/* harmony export */   "t3": function() { return /* binding */ clevertapDayTradeDebtRatioModalViewed; },
/* harmony export */   "tG": function() { return /* binding */ clevertapPortfolioOrderViewed; },
/* harmony export */   "v8": function() { return /* binding */ clevertapOrderDone; },
/* harmony export */   "vM": function() { return /* binding */ clevertapStockSelected; },
/* harmony export */   "xA": function() { return /* binding */ clevertapOrderDetailAmend; },
/* harmony export */   "xC": function() { return /* binding */ clevertapBuyError; },
/* harmony export */   "xh": function() { return /* binding */ clevertapOrderConfirmedSuccess; },
/* harmony export */   "xs": function() { return /* binding */ clevertapDayTradeActivationSuccessViewed; },
/* harmony export */   "y8": function() { return /* binding */ clevertapOrderConfirmed; },
/* harmony export */   "yr": function() { return /* binding */ clevertapPortfolioViewed; }
/* harmony export */ });
/* unused harmony exports generateSymbolType, clevertapTransactionOrderFailed, clevertapTransactionOrderFailedConfirmed, clevertapTransactionOrderAlert, clevertapBuyStockContinue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42227);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29097);
/* harmony import */ var _virtualTrading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29351);
// List of clevertap event for stockbit securities
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
// Clevertap event is wrapped with high order function
// to separate concern with existing code.








// Symbol type for clevertap is different from
// exisitng API response
function generateSymbolType(symbol) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol.split("-"), 2), symbolType = ref[1];
    if (!symbolType) {
        return "Normal";
    }
    if (symbolType.toUpperCase()[0] === "R") {
        return "Right";
    }
    if (symbolType.toUpperCase()[0] === "W") {
        return "Warrant";
    }
    return "";
}
function clevertapOrderDetailCancel() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", orderType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Buy";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_SELECTED */ .Le, {
        Type: type,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_VIEWED */ .Tf);
}
function clevertapOrderDetailCancelConfirmed(param) {
    var symbol = param.symbol, orderType = param.orderType, expiry = param.expiry, leverage = param.leverage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_CONFIRMED */ .fR, {
        symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Expiry: expiry,
        "Leverage Type": leverage
    });
}
function clevertapOrderDetailAmend(param) {
    var _type = param.type, type = _type === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _type, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_AMEND_SELECTED */ .fg, {
        Type: type,
        symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapOrderDetailAmendViewed(param) {
    var symbol = param.symbol, orderType = param.orderType, type = param.type;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_VIEWED */ .z8, {
        Symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Type: type
    });
}
function clevertapOrderQuantityAdjusted(param) {
    var symbol = param.symbol, orderType = param.orderType, adjustedType = param.adjustedType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_QUANTITY_ADJUSTED */ .gW,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_QUANTITY_ADJUSTED */ .sR,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPlaced(param) {
    var orderType = param.orderType, symbol = param.symbol, price = param.price, lot = param.lot, gainLoss = param.gainLoss, totalLot = param.totalLot, tradingBalancePercentage = param.tradingBalancePercentage, status = param.status, expiry = param.expiry, type = param.type, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PLACED */ .gg,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "% Trading Balance": tradingBalancePercentage,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PLACED */ .vc,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "Gain/Loss %": gainLoss,
            "% Total Lot": totalLot,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPreviewed(param) {
    var symbol = param.symbol, orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PREVIEWED */ .L9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PREVIEWED */ .q7,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_PREVIEWED */ .jG,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderCanceled(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CANCELED */ .lE,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CANCELED */ .dT,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CANCELED */ .a,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmed(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED */ .ee,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED */ .ZF,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type,
            Expiry: expiry,
            "Balance Lot": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CONFIRMED */ .Dn,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmedSuccess(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderId = param.orderId, orderType = param.orderType, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry;
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (currentUrl.includes("symbol")) {
        if (currentUrl.includes("chartbit")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
        } else {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
        }
    } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
    } else if (currentUrl.includes("portfolio")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
    } else if (currentUrl.includes("watchlist")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
    }
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED_SUCCESS */ .p3,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED_SUCCESS */ .LD,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderReceived(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_RECEIVED */ .Hm,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_RECEIVED */ .n2,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderDone(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_DONE */ .g1,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_DONE */ .xc,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapExchangeFee(orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_SELECTED */ .tI);
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_VIEWED */ ._e, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
}
function clevertapChangeStock() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_STOCK_VIEWED */ .jr);
}
function clevertapBuyError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ERROR_PAGE */ .IU, {
        Reason: "Insufficient Trading Limit"
    });
}
function clevertapPortfolioSell(param) {
    var _tradingType = param.tradingType, tradingType = _tradingType === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _tradingType, source = param.source, gainLoss = param.gainLoss, symbol = param.symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SELL_STOCK_SELECTED */ .vf, {
        Type: tradingType,
        Source: source,
        "Gain/Loss %": gainLoss,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioCompanySell(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_COMPANY_SELL_STOCK_SELECTED */ .JW, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioBuyMore(symbol, gainLoss) {
    var tradingType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_BUY_MORE_SELECTED */ ._O, {
        Symbol: symbol,
        "Gain / Loss %": gainLoss,
        Type: tradingType
    });
}
function clevertapViewChartSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEW_CHART_SELECTED */ .J1, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapSetPriceAlertSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SET_PRICE_ALERT_SELECTED */ .ef, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapPortfolioViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, portfolioType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .PORTFOLIOS_TYPE.regular */ .ub.regular;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEWED */ .tA, {
        Type: tradingType,
        "Portfolio List": portfolioType
    });
}
function clevertapPortfolioOrderViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Order";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_ORDER_VIEWED */ .zF, {
        Type: tradingType,
        Filter: (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(filter)
    });
}
function clevertapOrderViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_VIEWED */ .dz);
}
function clevertapOrderDetailViewed(param) {
    var orderType = param.orderType, status = param.status, rejectReason = param.rejectReason, expiry = param.expiry, symbol = param.symbol, type = param.type, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _dayTradeForceSell = param.dayTradeForceSell, dayTradeForceSell = _dayTradeForceSell === void 0 ? false : _dayTradeForceSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_VIEWED */ .v9, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        Status: status,
        "Reject Reason": rejectReason,
        Expiry: expiry,
        Symbol: symbol,
        Type: type,
        "Symbol Type": generateSymbolType(symbol),
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": dayTradeForceSell ? "Force Sell" : "Regular"
    });
}
function clevertapStockSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_SELECTED */ .B);
}
function clevertapExerciseClicked(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_EXERCISE_CLICKED */ ._g, {
        Symbol: symbol
    });
}
function clevertapExerciseViewed(param) {
    var symbol = param.symbol, share = param.share;
    return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_VIEWED */ .dW, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share
    });
}
function clevertapExerciseSelected(param) {
    var symbol = param.symbol, share = param.share, stockOnHandPercentage = param.stockOnHandPercentage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_SELECTED */ .Nq, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share,
        "% Stock on Hand": stockOnHandPercentage
    });
}
function clevertapExerciseError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ERROR_PAGE */ .Vm, {
        Reason: "Melebihi Cash on Hand"
    });
}
function clevertapTransactionOrderFailed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED);
}
function clevertapTransactionOrderFailedConfirmed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED_CONFIRMED);
}
function clevertapTransactionOrderAlert() {
    clevertapEvent(TRANSACTION_ORDER_ALERT);
}
function clevertapBuyStockContinue() {
    clevertapEvent(BUY_STOCK_CONTINUE);
}
function clevertapPortfolioDetailViewed(param) {
    var symbol = param.symbol, gainLoss = param.gainLoss, exerciseable = param.exerciseable, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_STOCK_DETAIL_VIEWED */ .kC, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Gain/Loss %": gainLoss,
        Exercisable: exerciseable,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular"
    });
}
function clevertapPortfolioDetailExercise(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_DETAIL_EXERCISE_SELECTED */ .le, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapDayTradeActivationViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_VIEWED */ .jY);
}
function clevertapDayTradeTNCViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_TNC_VIEWED */ .hG);
}
function clevertapDayTradeActivationSuccessViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_VIEWED */ .DQ);
}
function clevertapDayTradeActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SELECTED */ .Av
    });
}
function clevertapDayTradeActivationDismissed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_DISMISSED */ .wK
    });
}
function clevertapDayTradeActivationSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUBMITTED */ .mX
    });
}
function clevertapDayTradeActivationSuccessSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_SELECTED */ .Go
    });
}
function clevertapDayTradeLeverageOptionViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_OPTION_VIEWED */ .zW);
}
function clevertapDayTradeLeverageActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED */ .TC
    });
}
function clevertapDayTradeAfterMarketViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_AFTER_MARKET_VIEWED */ .D1);
}
function clevertapDayTradeDebtRatioViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_VIEWED */ .nc);
}
function clevertapDayTradeDebtRatioSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED */ .Yu
    });
}
function clevertapDayTradeDebtRatioChipSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_CHIP_SELECTED */ .zt
    });
}
function clevertapDayTradeDebtRatioModalViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_MODAL_VIEWED */ .bK);
}
function clevertapDayTradeStockListViewed(param) {
    var _sourcePage = param.sourcePage, sourcePage = _sourcePage === void 0 ? "Company Page" : _sourcePage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_LIST_VIEWED */ .GK, {
        "Source Page": sourcePage
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_SORT_VIEWED */ .YM);
}
function clevertapDayTradeLeverageSelected(leverage) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7,
        Leverage: leverage
    });
}
function clevertapDayTradeSortSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_SELECTED */ .cc
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_APPLIED */ .Zy
    });
}
function clevertapDayTradeOrderTypeSelected(stock, orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_TYPE_SELECTED */ .YB,
        Stock: stock,
        "Buy Order Type": orderType
    });
}
function clevertapDayTradeSplitOrderSelected(toggle) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SPLIT_ORDER_SELECTED */ .CV,
        Toggle: toggle ? "On" : "Off"
    });
}
function clevertapDayTradeOrderDetailSelected(param) {
    var symbol = param.symbol, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_DETAIL_SELECTED */ .BY, {
        Symbol: symbol,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": forcedSell ? "Force Sell" : "Regular"
    });
}
function clevertapSecuritiesTradingPinViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_VIEWED */ .Hd);
}
function clevertapSecuritiesTradingPinSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_SUBMITTED */ .II, {
        Method: "PIN Input"
    });
}
function clevertapBuyOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_VIEWED */ .HA, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapSellOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_VIEWED */ .gE, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapAutoOrderOptionsViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_AUTO_ORDER_OPTIONS_VIEWED */ .YS);
}
function clevertapSetVisibleBalance() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SET_VISIBLE_BALANCE */ .G2);
}
function clevertapOrderTabSelected(tab) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Order Detail Action", {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_ORDER_TAB_SELECTED */ .Oc,
        "Transaction Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(tab)
    });
}


/***/ }),

/***/ 59140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ff": function() { return /* binding */ editStopOrder; },
/* harmony export */   "GP": function() { return /* binding */ editSmartOrder; },
/* harmony export */   "Xz": function() { return /* binding */ getStockData; },
/* harmony export */   "sU": function() { return /* binding */ postSmartOrder; },
/* harmony export */   "xB": function() { return /* binding */ postSmartOrderTnC; },
/* harmony export */   "xy": function() { return /* binding */ postStopOrder; },
/* harmony export */   "zW": function() { return /* binding */ smartOrderDelete; }
/* harmony export */ });
/* unused harmony export deleteStopOrder */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);




var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, true, false);
/**
  * @deprecated Use `postStopOrder` instead
*/ var postSmartOrder = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: [
            payload
        ]
    });
};
var postStopOrder = function(data) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order/stop-order/v1/order"), data);
};
/**
 * @deprecated Use `editStopOrder` instead
 */ var editSmartOrder = function(payload) {
    return requestTrading.put("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), payload);
};
var editStopOrder = function(orderId) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", requestTrading.patch("/smart-order/stop-order/v1/order/".concat(orderId), data));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * @deprecated use deleteStopOrder instead
 */ var smartOrderDelete = function(payload) {
    return requestTrading.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: payload
    });
};
var deleteStopOrder = function(orderId) {
    return requestTrading.delete("".concat(API_TRADING_URL_V2, "/smart-order/stop-order/v1/order/").concat(orderId));
};
var getStockData = function(payload) {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        params: payload
    });
};
var postSmartOrderTnC = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order/tnc"), payload);
};


/***/ }),

/***/ 31532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingOperation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/alert.ts
var api_alert = __webpack_require__(56703);
// EXTERNAL MODULE: ./src/lib/api/smartOrder.ts
var smartOrder = __webpack_require__(59140);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/config.ts + 1 modules
var config = __webpack_require__(86408);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/types/transactions.ts
var VirtualExpiryId;
(function(VirtualExpiryId) {
    VirtualExpiryId[VirtualExpiryId["GoodForDay"] = 0] = "GoodForDay";
    VirtualExpiryId[VirtualExpiryId["GoodTillCanceled"] = 1] = "GoodTillCanceled";
})(VirtualExpiryId || (VirtualExpiryId = {}));

;// CONCATENATED MODULE: ./src/lib/stores/tradingOperation.ts
/* eslint-disable import/no-named-as-default-member */ 










var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var setIsLoading = function(key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        isLoading: true
    })));
};
var setError = function(error, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        error: error
    })));
};
var setData = function(data, message, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        data: data,
        message: message
    })));
};
var tradingOperationStore = (0,esm/* default */.ZP)(function(set) {
    return {
        postTradeCancelData: defaultData,
        addPriceAlertData: defaultData,
        postTradeBuyData: defaultData,
        postSmartOrderBuyData: defaultData,
        postTradeSellData: defaultData,
        postTradeAmendData: defaultData,
        postRequestExerciseData: defaultData,
        postDayTradeBuyData: defaultData,
        postDayTradeSellData: defaultData,
        postDayTradeAmendData: defaultData,
        postDayTradeCancelData: defaultData,
        deleteTrailingStopData: defaultData,
        deleteStopOrderData: defaultData,
        deleteBracketOrderData: defaultData,
        postTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, orderkey, symbol, gtc, isRealTrading, key, apiData, apiFunction, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, orderkey = param.orderkey, symbol = param.symbol, gtc = param.gtc, isRealTrading = param.isRealTrading;
                            key = "postTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            apiData = isRealTrading ? {
                                orderid: orderid,
                                orderkey: orderkey,
                                symbol: symbol,
                                gtc: gtc
                            } : {
                                order_id: orderid,
                                gtc: gtc === VirtualExpiryId.GoodTillCanceled
                            };
                            apiFunction = !isRealTrading ? config/* postCancel */.u : trade/* default.tradeCancel */.Z.tradeCancel;
                            _ctx.next = 8;
                            return apiFunction(apiData);
                        case 8:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            setError("Attempt to cancel trade failed", key, set);
                            throw new Error("Attempt to cancel trade failed");
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        addPriceAlert: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var name, command, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            name = param.name, command = param.command;
                            key = "addPriceAlertData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return api_alert/* default.addPriceAlert */.Z.addPriceAlert(name, command);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve exercise list failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(buyData) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.tradeBuy */.Z.tradeBuy(buyData);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(buyData) {
                return _ref.apply(this, arguments);
            };
        }(),
        postSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postSmartOrderBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,smartOrder/* postStopOrder */.xy)(payload);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post smart order failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sellData) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.tradeSell */.Z.tradeSell(sellData);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(sellData) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orders) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.bulkTradeAmend */.Z.bulkTradeAmend(orders);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orders) {
                return _ref.apply(this, arguments);
            };
        }(),
        postRequestExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderKey, shares, stockCode, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderKey = param.orderKey, shares = param.shares, stockCode = param.stockCode;
                            key = "postRequestExerciseData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.postRequestExercise */.Z.postRequestExercise({
                                stockCode: stockCode,
                                shares: shares,
                                orderKey: orderKey
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post request exercise data failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        editSmartOrder: function(orderId) {
            return function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                    var response, _data, data, _$error, errorType, message;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return (0,smartOrder/* editStopOrder */.Ff)(orderId)(payload);
                            case 3:
                                response = _ctx.sent;
                                if (response.data) {
                                    _ctx.next = 6;
                                    break;
                                }
                                throw new Error("Error while fetching data");
                            case 6:
                                _data = response.data, data = _data.data, _$error = _data.error, errorType = _data.error_type, message = _data.message;
                                if (!(_$error || errorType)) {
                                    _ctx.next = 9;
                                    break;
                                }
                                throw new Error(message);
                            case 9:
                                return _ctx.abrupt("return", {
                                    data: data,
                                    message: message
                                });
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](0);
                                return _ctx.abrupt("return", {
                                    error: _ctx.t0
                                });
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            12
                        ]
                    ]);
                }));
                return function(payload) {
                    return _ref.apply(this, arguments);
                };
            }();
        },
        // Day Trade
        postDayTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, multiplier, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares, multiplier = param.multiplier;
                            key = "postDayTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeBuy({
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                multiplier: multiplier
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares;
                            key = "postDayTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeSell({
                                symbol: symbol,
                                price: price,
                                shares: shares
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, price, shares, multiplier, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, price = param.price, shares = param.shares, multiplier = param.multiplier;
                            key = "postDayTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.dayTradeAmend */.Z.dayTradeAmend({
                                orderid: orderid,
                                price: price,
                                shares: shares,
                                multiplier: multiplier
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post day trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderKey) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postDayTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.dayTradeCancel */.Z.dayTradeCancel(orderKey);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 9;
                                break;
                            }
                            setError("Attempt to cancel day trade failed", key, set);
                            throw new Error("Attempt to cancel day trade failed");
                        case 9:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postDayTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orderKey) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteTrailingStop: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteTrailingStopData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteTrailingStop */.Z.deleteTrailingStop(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to delete trailing stop failed", key, set);
                            throw new Error("Attempt to delete trailing stop failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteStopOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteStopOrderData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteStopOrder */.Z.deleteStopOrder(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to cancel stop order failed", key, set);
                            throw new Error("Attempt to cancel stop order failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteBracketOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteBracketOrderData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteBracketOrder */.Z.deleteBracketOrder(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to cancel bracket order failed", key, set);
                            throw new Error("Attempt to cancel bracket order failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var tradingOperation = (tradingOperationStore);


/***/ })

}]);